import { IVAV } from '@/Core.Service.Domain/Controls/Controls.Common/types/index.ts';

const apiVersion = 'v1';

const getVAVById = async (
  vavId: number,
  options: { signal?: AbortSignal } = {}
): Promise<IVAV> => {
  try {
    const { signal } = options;

    const response = await window.axios.get(
      `/${apiVersion}/VariableAirVolumeUnits/${vavId}`,
      { signal }
    );

    const { data } = response.data;
    return data as IVAV;
  } catch (err) {
    return Promise.reject(err);
  }
};

const getVAVsBySiteId = async (siteId: string | number) => {
  const response = await window.axios.get(
    `${apiVersion}/VariableAirVolumeUnits/latest-readings?siteid=${siteId}`
  );

  const { data } = response.data;
  return data as IVAV[];
};

const setVAVSetpoint = async (
  vavId: number,
  setpoints: Partial<IVAV>
): Promise<void> => {
  try {
    await window.axios.put(
      `/${apiVersion}/VariableAirVolumeUnits/${vavId}/settings`,
      {
        changedSettings: {
          occupiedSetpoint: setpoints.occupiedSetpoint,
          maxOccupiedSetpoint: setpoints.maxOccupiedSetpoint,
          minOccupiedSetpoint: setpoints.minOccupiedSetpoint,
          heatingSignal: setpoints.heatingSignal,
          coolingSignal: setpoints.coolingSignal,
          desiredAirflow: setpoints.desiredAirflow,
        },
      }
    );
  } catch (err) {
    return Promise.reject(err);
  }
};

const getVAVSettingsMessages = async (vavId: number) => {
  try {
    const response = await window.axios.get(
      `${apiVersion}/VariableAirVolumeUnits/${vavId}/history`
    );

    const { data } = response.data;
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

const updateVAVById = async (vav: IVAV) => {
  const {
    deviceId,
    friendlyName,
    siteLocationId,
    equipmentId = null,
    isActive = true,
  } = vav;
  try {
    await window.axios.put(`${apiVersion}/VariableAirVolumeUnits/${deviceId}`, {
      friendlyName,
      siteLocationId,
      equipmentId,
      isActive,
    });
  } catch (err) {
    return Promise.reject(err);
  }
};

const deleteVAVById = async (vavId: number) => {
  try {
    await window.axios.delete(`${apiVersion}/VariableAirVolumeUnits/${vavId}`);
  } catch (err) {
    return Promise.reject(err);
  }
};

const getSitesWithVAVs = async () => {
  try {
    const result = await window.axios.get(
      `/${apiVersion}/VariableAirVolumeUnits/sites`
    );
    const { data } = result.data;
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

const getVAVMappings = async (siteId: string | number) => {
  try {
    const response = await window.axios.get(
      `/${apiVersion}/VariableAirVolumeUnits/sites/${siteId}/mappings`
    );
    const { data } = response.data;
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

export default {
  getVAVById,
  getVAVsBySiteId,
  setVAVSetpoint,
  getVAVSettingsMessages,
  updateVAVById,
  deleteVAVById,
  getSitesWithVAVs,
  getVAVMappings,
};
